import { render, staticRenderFns } from "./matter.vue?vue&type=template&id=6490cfc4&scoped=true&"
import script from "./matter.vue?vue&type=script&lang=js&"
export * from "./matter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6490cfc4",
  null
  
)

export default component.exports